export default __webpack_public_path__ + "static/media/csv.610f6deb.svg";